import React from 'react';

import ActionFixedButton from 'src/features/register/ActionFixedButton';
import Description from 'src/features/register/Description';
import QR from 'src/features/register/QR';
import styled from 'styled-components';

const RegisterStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

export default function Register() {
  return (
    <RegisterStyled>
      <Description />
      <QR />
      <ActionFixedButton />
    </RegisterStyled>
  );
}
